import TableContainer from "components/Common/TableContainer"
import React, { useMemo, useRef, useState } from "react"
import { Button, Input } from "reactstrap"
import { isNumber } from "lodash"
import { getQuantityFromSubmited } from "utils/providerOutUtils"
import { checkForMinusNumber, numberIsSame } from "utils/utils"
import SAlert from "components/Alert"

const ReceiptListForAdjustment = ({
  data,
  onSubmitAddHandler,
  submited,
  adjustmentType,
}) => {
  const [outQuantity, setOutQuantity] = useState([])
  const inputRef = useRef()

  const handleChangeQuantity = (e, receipt) => {
    if (checkForMinusNumber(e)) {
      e.target.value = 0
      return false
    }
    // if (e.target.value < 0 && !isNumber(e.target.value)) {
    //   return false
    // }
    inputRef.current = receipt.unique_id
    const newItem = { id: receipt.unique_id, quantity: e.target.value }
    setOutQuantity(prev =>
      prev.some(p => p.id === receipt.unique_id)
        ? prev.map(qty =>
            qty.id === newItem.id ? { ...qty, quantity: e.target.value } : qty
          )
        : [...prev, newItem]
    )
  }

  function showTotal(quantity, id) {
    const value = outQuantity.find(qty => qty.id === id)
    if (value) {
      return (
        quantity -
        getQuantityFromSubmited(submited, id) -
        Math.abs(value.quantity)
      )
    } else {
      return quantity - getQuantityFromSubmited(submited, id)
    }
  }

  const onAddHandler = (outQuantityValue, receipt) => {
    const quantity = outQuantityValue.quantity

    // Validate for Decrease type
    if (adjustmentType === "Decrease") {
      const currentBalance = receipt?.in_qty_per_ip || 0
      const alreadySubmitted = getQuantityFromSubmited(
        submited,
        receipt?.unique_id
      )
      const availableBalance = currentBalance - alreadySubmitted

      if (quantity > availableBalance) {
        SAlert({
          text: "Not enough stock. Available balance: " + availableBalance,
          status: "error",
        })
        return
      }
    }

    const result = {
      qty: quantity,
      provider_in_id: outQuantityValue.id,
      batch_number: receipt?.batch_number,
      out_quantity: quantity,
    }

    onSubmitAddHandler(result)
    onResetReceiptList()
  }

  const onResetReceiptList = () => {
    setOutQuantity([])
    inputRef.current.value = ""
  }

  function checkForAdd(receipt) {
    const outQuantityValue = outQuantity.find(
      qty => qty.id === receipt?.unique_id
    )

    if (outQuantityValue) {
      return (
        <Button
          className="btn btn-sm btn-info"
          onClick={() => onAddHandler(outQuantityValue, receipt)}
          type="button"
        >
          Add
        </Button>
      )
    } else {
      return
    }
  }

  const columns = useMemo(
    () => [
      {
        Header: "UNFPA ITEM ID",
        accessor: "item.unfp_item_name",
        filterable: false,
        disableFilters: true,
        Cell: cellProps => {
          return cellProps?.value
        },
      },
      {
        Header: "IP- ITEM DESCRIPTION",
        accessor: "item.ip_item_description",
        filterable: false,
        disableFilters: true,
        Cell: cellProps => {
          return cellProps?.value
        },
      },
      {
        Header: "UNFPA UOM",
        accessor: "item",
        id: "unpfa_item",
        filterable: false,
        disableFilters: true,
        Cell: cellProps => {
          return `${cellProps?.value?.uom} ${
            cellProps?.value?.unfpa_uom_quantity > 1 &&
            cellProps?.value?.unfpa_uom_quantity
          }`
        },
      },
      {
        Header: "IP UOM",
        accessor: "item",
        id: "ip_item",
        filterable: false,
        disableFilters: true,
        Cell: cellProps => {
          return `${cellProps?.value?.ip_unit_umo} ${
            cellProps?.value?.ip_uom_quantity > 1 &&
            cellProps?.value?.ip_uom_quantity
          }`
        },
      },
      {
        Header: "BATCH NUMBER",
        accessor: "batch_number",
        filterable: false,
        disableFilters: true,
        Cell: cellProps => {
          return cellProps?.value
        },
      },
      {
        Header: "EXPIRE DATE",
        accessor: "expire_date",
        filterable: false,
        disableFilters: true,
        Cell: cellProps => {
          return cellProps?.value
        },
      },
      {
        Header: "CURRENT BALANCE",
        accessor: "in_qty_per_ip",
        filterable: false,
        disableFilters: true,
        Cell: cellProps => {
          return cellProps?.value
        },
      },
      {
        Header: "Quantity",
        filterable: false,
        disableFilters: true,
        Cell: ({ row }) => {
          return (
            <Input
              key={row?.original?.unique_id}
              type="number"
              name={`quantity-${row?.original.unique_id}`}
              onWheel={e => e.target.blur()}
              ref={inputRef}
              min={0}
              value={
                outQuantity?.find(qty => qty.id === row?.original?.unique_id)
                  ?.quantity
              }
              onChange={e => handleChangeQuantity(e, row?.original)}
              autoFocus={row?.original?.unique_id === inputRef.current}
            />
          )
        },
      },

      {
        Header: "",
        id: "addDistribute",
        filterable: false,
        disableFilters: true,
        Cell: ({ row }) => {
          return checkForAdd(row?.original)
        },
      },
    ],
    [handleChangeQuantity, checkForAdd]
  )

  return (
    <React.Fragment>
      <div className="mb-4 h4 card-title">Items</div>
      <TableContainer
        columns={columns}
        data={data}
        isGlobalFilter={false}
        isAddOptions={false}
        customPageSize={6}
      />
    </React.Fragment>
  )
}

export default ReceiptListForAdjustment
